const fetchWorkOrder = async (org_id, work_order_id) => {
    return await fetch(
        `/dashboard/organizations/${org_id}/work_orders/${work_order_id}.json`,
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(async r => {
            let json = await r.json();
            return json.data
        });
}
const updateWorkOrderStatus = async (org_id, work_order_id, status) => {
    return await fetch(
        `/dashboard/organizations/${org_id}/work_orders/${work_order_id}/update_status`,
        {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({status: status})
        })
        .then(async r => {
            return await r.json()
        });
}
export {fetchWorkOrder, updateWorkOrderStatus}